import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { LoginFormComponent, ResetPasswordFormComponent, CreateAccountFormComponent, ChangePasswordFormComponent, CreatePasswordFormComponent, TwoFactorCodeFormComponent } from './components';
import { AuthGuardService } from './services';

import { SideNavOuterToolbarComponent, UnauthenticatedContentComponent } from './layouts';

import { CrmContactListComponent } from './pages/crm-contact-list/crm-contact-list.component';
import { CrmContactDetailsComponent } from './pages/crm-contact-details/crm-contact-details.component';
import { PlanningTaskListComponent } from './pages/planning-task-list/planning-task-list.component';
import { PlanningTaskDetailsComponent } from './pages/planning-task-details/planning-task-details.component';
import { AnalyticsDashboardComponent } from './pages/analytics-dashboard/analytics-dashboard.component';
import { AnalyticsSalesReportComponent } from './pages/analytics-sales-report/analytics-sales-report.component';
import { AnalyticsGeographyComponent } from './pages/analytics-geography/analytics-geography.component';
import { PlanningSchedulerComponent } from './pages/planning-scheduler/planning-scheduler.component';
import { AppSignInComponent } from './pages/sign-in-form/sign-in-form.component';
import { AppSignUpComponent } from './pages/sign-up-form/sign-up-form.component';
import { AppResetPasswordComponent } from './pages/reset-password-form/reset-password-form.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
import { WorkRequestDetailsComponent  } from './pages/work-request-details/work-request-details.component';
import { WorkRequestListComponent  } from './pages/work-request-list/work-request-list.component';
import { AppCreatePasswordComponent } from './pages/create-password-form/create-password-form.component';

const routes: Routes = [
	{
		path: 'auth',
		component: UnauthenticatedContentComponent,
		children: [
			{
				path: 'login',
				component: LoginFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'two-factor-code',
				component: TwoFactorCodeFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'reset-password',
				component: ResetPasswordFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'create-account',
				component: CreateAccountFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'change-password',
				component: ChangePasswordFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'create-password/:recoveryCode',
				component: CreatePasswordFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: '**',
				redirectTo: 'login',
				pathMatch: 'full',
			},
		]
	},
	{
		path: '',
		component: SideNavOuterToolbarComponent,
		children: [
			{
				path: 'crm-contact-list',
				component: CrmContactListComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'crm-contact-details',
				component: CrmContactDetailsComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'planning-task-list',
				component: PlanningTaskListComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'planning-task-details',
				component: PlanningTaskDetailsComponent
			},
			{
				path: 'planning-scheduler',
				component: PlanningSchedulerComponent
			},
			{
				path: 'analytics-dashboard',
				component: AnalyticsDashboardComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'analytics-sales-report',
				component: AnalyticsSalesReportComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'analytics-geography',
				component: AnalyticsGeographyComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'sign-in-form',
				component: AppSignInComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'sign-up-form',
				component: AppSignUpComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'reset-password',
				component: AppResetPasswordComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'create-password',
				component: AppCreatePasswordComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'change-password',
				component: ChangePasswordFormComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'user-profile',
				component: UserProfileComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'work-request-details/:id',
				component: WorkRequestDetailsComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: 'work-request-list',
				component: WorkRequestListComponent,
				canActivate: [AuthGuardService],
			},
			{
				path: '**',
				redirectTo: 'work-request-list',
				pathMatch: 'full',
			},
		]
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { useHash: true, }),
		BrowserModule,
	],
	providers: [AuthGuardService],
	exports: [RouterModule],
	declarations: [],
})
export class AppRoutingModule { }
